import React, {
  FC,
  useState,useEffect
} from 'react';
import { Button, Radio} from '@scuf/common';
import {
  modelStageUpdate
} from 'src/slices/contextSlice';
import { useAppDispatch } from 'src/store';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from 'src/components/Snackbar/Snackbar';


export const SetActiveStage: FC<{header:string, modelData: any, refreshEditScreen:Function, handleClose:Function}> = ({header, modelData, refreshEditScreen, handleClose}) => {
    const [currentStage, setCurrentStage] = useState("0-Setup");
    const [currentStageinDB, setCurrentStageinDB] = useState("0-Setup");

    const dispatch = useAppDispatch();


    useEffect(() => {
      let activestage = modelData[0].stage.filter((data:any) => { return data["is_active"]===true })
      setCurrentStage(`${activestage[0].stage_id}-${activestage[0].stage_name}`)
      setCurrentStageinDB(`${activestage[0].stage_id}-${activestage[0].stage_name}`)
    }, []);


const onStageUpdate=()=>{
  const updateModelStagePostData = {
    model_id: modelData[0].model_id,
    stage_id:Number(currentStage.charAt(0))
  };

  dispatch(modelStageUpdate(updateModelStagePostData)).then((response: any) => {
    toast(<Snackbar toastMessage={"Model Stage Updated"} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
      refreshEditScreen();
}).catch(() => {
       toast(<Snackbar toastMessage={"Model Stage Update Failed"} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
     });

}

  return (
    <div className='right-container'>
      <div className='right-container-step-one'>
        <label className="label">
              {"Set Active Stage"}
        </label>
        {
          modelData[0].stage.map((option:any)=>{
            return(
              <div>
                <Radio
                    label={`${option.stage_id}-${option.stage_name}`}
                    checked={currentStage === `${option.stage_id}-${option.stage_name}`}
                    onChange={() => setCurrentStage(`${option.stage_id}-${option.stage_name}`)}
                />
            </div>
            )
          })
        }
 
        <div className='right-container-step-one-footer'>
          <Button
            className='action-btn custom-btn'
            size='small'
            type='secondary'
            textTransform={false}
            content='Cancel'
            onClick={() => handleClose()}
          />
          <Button
            className='action-btn custom-btn'
            size='small'
            textTransform={false}
            disabled={currentStageinDB===currentStage}
            // disabled={disableButton || editLoading}
            // loading={editLoading}
            onClick={() => onStageUpdate()}
            content='Update'
          />
        </div>
      </div>
    </div>
    
  );
};

export default SetActiveStage;